//
// # Theme DOM Application (browser-only)
//
// The background side-effect that used to live in `Theme.set` (DrawCore). It was
// moved out so the render core stays free of DOM globals and type-checks under a
// non-DOM lib on the headless server. Call this right after `Theme.set()` in the
// browser to apply the theme's canvas background.
//

import { Theme } from "DrawCore/src/style/theme";

// Apply the given theme's background to the document: the body (standalone Web
// view) and a CSS custom property on :root (so the IDE host can pick it up for
// the editor pane).
export function applyThemeToDom(theme: Theme): void {
  const bg = Theme.isDark(theme) ? "black" : "white";
  document.body.style.backgroundColor = bg;
  document.documentElement.style.setProperty("--editor-canvas-bg", bg);
}
